import classes from './PasswordConfirm.module.scss';
// pages/PasswordConfirmPage.tsx
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { useConfirmPasswordChange } from 'hooks/usePasswordChange';
import { Button } from 'ui';
import { getApiErrorMessage } from 'utils/getApiErrorMessage';
import { BrandLoader } from 'ui/BrandLoader/BrandLoader';

export const PasswordConfirm = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [autoConfirmed, setAutoConfirmed] = useState(false);

  const {
    mutate: confirmPassword,
    isPending,
    isSuccess,
    isError,
    error,
  } = useConfirmPasswordChange();

  // Автоматически подтверждаем при загрузке
  useEffect(() => {
    if (token && !autoConfirmed) {
      confirmPassword({ token });
      setAutoConfirmed(true);
    }
  }, [token, autoConfirmed, confirmPassword]);

  if (!token) {
    return (
      <section className={classes.wrapper}>
        <main className={classes.container}>
            <div className={classes.errortoken}>Неверная ссылка</div>
            <h2> Ссылка для подтверждения не содержит токен.</h2>
          <Button onClick={() => navigate('/login')}>Перейти к входу</Button>
        </main>
      </section>
    );
  }

  if (isPending) {
    return (
      <section className={classes.wrapper}>
        <main className={classes.container}>
          <h2>Подтверждение пароля...</h2>
          <p>Пожалуйста, подождите</p>
          <BrandLoader center />
        </main>
      </section>
    );
  }

  if (isSuccess) {
    return (
      <section className={classes.wrapper}>
        <main className={classes.container}>
          <div className={classes.confirmpass}>Пароль успешно изменен!</div>
          <p>Теперь вы можете войти с новым паролем.</p>
          <Button
            variant='filled'
            onClick={() => navigate('/login')}
            style={{ marginTop: '20px' }}
          >
            Войти в аккаунт
          </Button>
        </main>
      </section>
    );
  }

  if (isError) {
    return (
      <section className={classes.wrapper}>
        <main className={classes.container}>
          <div className={classes.errorpass}> Ошибка подтверждения </div>
          <p>При смене пароля что-то пошло не так</p>
          {error && (
            <div
              style={{
                background: '#ffebee',
                padding: '10px',
                borderRadius: '5px',
                margin: '20px 0',
                color: '#c62828',
              }}
            >
              {getApiErrorMessage(error, 'Неизвестная ошибка')}
            </div>
          )}
          <div className={classes.button_confirmpass}>
           <Button
            variant='outlined'
            onClick={() => confirmPassword({ token })}
            disabled={isPending}
            style={{
            height: 53,
            color: 'black'
            }}
          >
            Повторить
          </Button>
            <Button variant='filled' onClick={() => navigate('/login')}>
              Перейти к входу
            </Button>
          </div>
        </main>
      </section>
    );
  }

  return null;
};
